import { Component, Input, OnDestroy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import moment from 'moment';
import { bcComponentsConstants } from 'common/common/constants/components';

@Component({
  selector: 'workitem-activity-indicator',
  templateUrl: './workitem-activity-indicator.component.html',
  styleUrls: ['./workitem-activity-indicator.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkitemActivityIndicatorComponent implements OnDestroy {
  public timerDisplayClass: string = '';
  public timerDisplay: string = '';

  private _timerInterval: number = null;
  private _wrapupIconEnabled: boolean = false;

  @Input() unansweredMessageCount: number = 0;
  @Input() secondsRemainingDisplay: string = '';
  @Input() optionalClassName: string = '';
  @Input() showSecondsRemaining: boolean = false;
  @Input() forceDisableRedDots: boolean = false;
  @Input() showWrapUpIndicator: boolean = false;
  @Input() showElapsedTimer: boolean = false;

  constructor(private _changeDetector: ChangeDetectorRef) {}

  ngOnDestroy() {
    this._stopTimer();
  }

  get unansweredMessageIcon(): string {
    return this.unansweredMessageCount === 1 ? 'dot' : this.unansweredMessageCount === 2 ? 'dots-two' : 'dots-three';
  }

  get isWrapUpIconVisible(): boolean {
    return this.showWrapUpIndicator && this.forceDisableRedDots;
  }

  public showCounter(): boolean {
    if (this.showElapsedTimer && !this.showSecondsRemaining && (this._chatUnanswered() || this._chatClosed())) {
      this._restartTimerIfRequired();
      this._startTimer();

      return true;
    } else {
      this._stopTimer();

      return false;
    }
  }

  public setTimerDisplayColor(counter: number): void {
    const classnames: string[] = [];

    classnames.push(this.forceDisableRedDots ? bcComponentsConstants.TIMER_CLASSNAME_WRAPUP : bcComponentsConstants.TIMER_CLASSNAME_UNANSWERED);

    if (counter >= bcComponentsConstants.TIMER_DELAY_HIGHLIGHT) {
      classnames.push(bcComponentsConstants.TIMER_CLASSNAME_HIGHLIGHT);
    }

    this.timerDisplayClass = classnames.join(' ');
  }

  private _chatUnanswered(): boolean {
    return this.unansweredMessageCount > 0 && !this.forceDisableRedDots;
  }

  private _chatClosed(): boolean {
    return this.showWrapUpIndicator && this.forceDisableRedDots;
  }

  private _stopTimer(): void {
    if (!this._timerInterval) {
      return;
    }

    window.clearInterval(this._timerInterval);
    this._timerInterval = null;
    this.timerDisplay = '';
  }

  private _restartTimerIfRequired(): void {
    if (this.forceDisableRedDots && !this._wrapupIconEnabled) {
      this._wrapupIconEnabled = true;

      if (this._timerInterval) {
        this._stopTimer();
      }
    } else if (!this.forceDisableRedDots) {
      this._wrapupIconEnabled = false;
    }
  }

  private _startTimer(): void {
    if (this._timerInterval) {
      return;
    }

    let currentTimer: number = 0;

    this.setTimerDisplayColor(currentTimer);

    this._timerInterval = window.setInterval(() => {
      currentTimer++;

      if (currentTimer === bcComponentsConstants.TIMER_DELAY_HIGHLIGHT) {
        this.setTimerDisplayColor(currentTimer);
      }

      if (currentTimer >= bcComponentsConstants.TIMER_DELAY) {
        this.timerDisplay = this._getFormatedTimer(currentTimer);
      }
      this._changeDetector.detectChanges();
    }, 1000);
  }

  private _getFormatedTimer(seconds: number): string {
    const milliseconds: number = seconds * 1000;
    const dateFormat: string = seconds >= 60 ? 'm:ss' : ':ss';

    return moment(milliseconds).utc().format(dateFormat);
  }
}
